import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getAllResumesDossier() {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/dossiers/resume";
    const response = await axios.get(url);
    return response.data;
  },
  async getDossierCaptcha() {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/dossiers/init";
    const response = await axios.post(url);
    return response.data;
  },
  async create(dossier) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/dossiers";
    const response = await axios.post(url, dossier).catch(error => {
      return error.response;
    });
    return response.data;
  },
  async delete(id) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/dossier/" + id;
    const response = await axios.delete(url);
    return response.data;
  },
  sendMailInscription(id) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/dossier/" +
      id +
      "/mail_inscription";
    axios.get(url);
  },
  async setEtatBrouillon(id, parameters = null) {
    return await this.setEtat(id, "brouillon", parameters);
  },
  async setEtatExamenAdministratif(id, dossier) {
    const parameters = {
      codeAcces: dossier.codeAcces
    };
    return await this.setEtat(id, "examen_administratif", parameters);
  },
  async setEtatAttente(id) {
    return await this.setEtat(id, "attente");
  },
  async setEtatExamenCRA(id) {
    return await this.setEtat(id, "examen_cra");
  },
  async setAllEtatExamenCRA() {
    const url =
      process.env.VUE_APP_BACKEND_API_URL + "/api/dossiers/examen_cra";
    const response = await axios.post(url);
    return response.data;
  },
  async setEtatValide(id, dossier) {
    return await this.setEtat(id, "valide", dossier);
  },
  async setEtatRefuse(id, dossier) {
    return await this.setEtat(id, "refuse", dossier);
  },
  async setEtatExpire(id) {
    return await this.setEtat(id, "expire");
  },
  async setEtatBloque(id) {
    return await this.setEtat(id, "bloque");
  },
  async setEtat(id, etat, parameters = null) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL + "/api/dossier/" + id + "/" + etat;
    let data = {};
    if (parameters) data = parameters;
    const response = await axios.put(url, data);
    return response.data;
  },
  async update(id, code, dossier) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/dossier/" +
      dossier.id +
      "?code=" +
      dossier.codeAcces;
    const response = await axios.put(url, dossier);
    return response.data;
  },
  async getJustificatifs(id) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/dossier/" +
      id +
      "/justificatifs";
    const response = await axios.get(url);
    return response.data;
  },
  async getJustificatif(id) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL + "/api/dossier/justificatif/" + id;
    const response = await axios.get(url, { responseType: "blob" });
    return response.data;
  },
  getJustificatifURL(justificatif) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/dossier/justificatif/" +
      justificatif.id
    );
  },
  async addJustificatif(id, code, file) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/dossier/" +
      id +
      "/justificatifs" +
      "?code=" +
      code;
    let formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(url, formData);
    return response.data;
  },
  async get(id, code = null) {
    let url = process.env.VUE_APP_BACKEND_API_URL + "/api/dossier/" + id;
    if (null !== code) url += "?code=" + code;
    const response = await axios.get(url);
    return response.data;
  },
  getPDFURL(id, code = null) {
    let url =
      process.env.VUE_APP_BACKEND_API_URL + "/api/dossier/" + id + "/pdf";
    if (null !== code) url += "?code=" + code;
    return url;
  },
  async getPDF(id, code = null) {
    const url = this.getPDFURL(id, code);
    const response = await axios.get(url, { responseType: "blob" });
    return response.data;
  }
};
